/**
 * Coming Soon Event form component
 * 
 * @module coming-soon-heart
 * @version 1.0.0
 * @extends HTMLElement
 */
class comingSoonHeartComponent extends HTMLElement {

    /**
     * Coming Soon Event form web component.
     * 
     * @constructor
     */
    constructor() {

        super();
        
        this.initEvents();
    }

    /**
     * Init events.
     * 
     * @returns {undefined}
     */
    initEvents() {

        window.dataLayer = window.dataLayer || [];

        window.addEventListener('load', () => {
            const btn = this.querySelector('button');
            const canBeSendable = btn.dataset.eventHeart === 'on' ? true : false;
            if(btn && canBeSendable){
                btn.addEventListener('click', (e) => {
                    console.log('event', e);
                    const dataSet = this.dataset;
                    const eventId = window.eventId || dataSet.title;
                    const image = dataSet.image || '';
                    const eventMarket = dataSet.marketing || '';
                    const email = dataSet.email || '';
                    const phone_number = dataSet.phone || '';
                    const first_name = dataSet.firstName || '';
                    const last_name = dataSet.lastName || '';

                    let referringUrl = dataSet.location || '';
                    let citySource = eventMarket;

                    btn.classList.add('active');
                    btn.style.pointerEvents = "auto";

                    // Check event ID
                    if(eventId) {

                        if(eventMarket != '') {
                            if(eventMarket.includes("New York") || eventMarket.includes("NY")) {
                                citySource = "New York";
                            }
                            else if(eventMarket.includes("Miami") || eventMarket.includes("MIA")) {
                                citySource = "Miami";
                            }
                            else if(eventMarket.includes("Los Angeles") || eventMarket.includes("LA")) {
                                citySource = "Los Angeles";
                            }
                            else if(eventMarket.includes("Chicago") || eventMarket.includes("CHI")) {
                                citySource = "Chicago";
                            }
                            else if(eventMarket.includes("Dallas") || eventMarket.includes("DAL")) {
                                citySource = "Dallas";
                            }
                            else {
                                citySource = "Online";
                            }
                        }

                        // Send event to data layer
                        window.dataLayer.push({
                            "event": "ComingSoonNotify",
                            "eventId": eventId,
                            "market": citySource,
                            "email": email,
                            "firstName": first_name || 'defaultFirstName',
                            "lastName": last_name || 'defaultLastName',
                            "referringUrl": referringUrl,
                            "phone_number": phone_number,
                            "image": image
                        });

                        // ---------------------- Bloomreach Events ----------------------
                        if(window.exponea) {

                            // Customer Tracking
                            exponea.identify(
                                {
                                    email_id: email,
                                },
                                {
                                    first_name: first_name,
                                    last_name: last_name,
                                    email: email
                                }
                            );

                            // Sign Up Event
                            exponea.track('sign_up_event', {
                                event: "ComingSoonNotify",
                                eventId: eventId,
                                market: citySource,
                                email: email,
                                first_name: first_name,
                                last_name: last_name,
                                referringUrl: referringUrl,
                                phone_number: phone_number,
                                image: image
                            });

                            // Consent Event - City
                            exponea.track('consent', {
                                email: email,
                                action: "accept",
                                category: citySource, 
                                valid_until: "unlimited",
                                message: "Don't Miss Out! Sign-up for event notifications"
                            });

                            // Consent Event - Marketing
                            exponea.track('consent', {
                                email: email,
                                action: "accept",
                                category: "Marketing", 
                                valid_until: "unlimited",
                                message: "Don't Miss Out! Sign-up for event notifications"
                            });

                            // Consent Event - SMS
                            exponea.track('consent', {
                                email: email,
                                action: "accept",
                                category: "SMS", 
                                valid_until: "unlimited",
                                message: "Plus - receive event announcements like special promotions or additional discounts that happen throughout the week"
                            });

                            /* Shopify Consent Event
                            exponea.track('shopify_consent', {
                                action: "accept",
                                category: "Marketing", 
                                valid_until: "unlimited"
                            });
                            */
                        }
                    }
                });
            }
        } , false);
    }

}

customElements.define('coming-soon-heart', comingSoonHeartComponent);